import { Typography, type TypographyProps } from "@octopus-energy/coral/atoms"

export function PageStepTitle(props: Omit<TypographyProps, "textAlign" | "textStyle">) {
    return (
        <Typography
            textAlign="center"
            textStyle="h3"
            {...props}
        />
    )
}
